import Vue from 'vue'

const state = {

}

const mutations = {

}

const getters = {

}

const actions = {

}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/interfaceText.js